document.addEventListener("DOMContentLoaded", () => {
  // Select logos
  const logos = {
    noNic: document.getElementById("zero-nicotine-product-logo"),
    nic: document.getElementById("nicotine-product-logo"),
    nix: document.getElementById("nixodine-product-logo"),
  };

  /**
   * Resets all logos to their default state.
   */
  const resetLogos = () => {
    Object.values(logos).forEach((logo) => logo?.classList.remove("active-logo"));
  };

  /**
   * Updates the active logo based on the selected strength.
   * @param {string} strength - The selected nicotine strength.
   */
  const updateLogos = (strength) => {
    resetLogos();

    if (strength === "0mg") {
      logos.noNic?.classList.add("active-logo");
    } else if (strength === "Nixodine") {
      logos.nix?.classList.add("active-logo");
    } else if (strength.includes("mg")) {
      logos.nic?.classList.add("active-logo");
    }

    console.log("Updated strength:", strength);
  };

  /**
   * Retrieves the currently selected labels from the variant picker.
   * @returns {string[]} Array of selected label text.
   */
  const getSelectedLabels = () => {
    const selectedLabels = document.querySelectorAll(
      ".variant-picker__option input[type='radio']:checked + label span"
    );
    selectedLabels.forEach((label) => {
      console.log("Selected Label:", label.textContent.trim());
    });
    return Array.from(selectedLabels).map((label) => label.textContent.trim());
  };

  /**
   * Initializes and sets up event listeners for variant picker options.
   */
  const initializeVariantPicker = () => {
    const variantOptions = document.querySelectorAll(".variant-picker__option");
    console.log("Found variant options:", variantOptions.length);

    if (variantOptions.length > 0) {
      variantOptions.forEach((option) => {
        const legend = option.querySelector(".variant-picker__option-info legend");
        const isNicotineOption = legend?.textContent.includes("Nicotine:");
        const isNixodineOption = legend?.textContent.includes("Nixodine:");

        if (isNicotineOption) {
          // Update logo for the initially selected option
          const initialInput = option.querySelector("input[type='radio']:checked");
          if (initialInput) {
            const initialLabel = initialInput.nextElementSibling.querySelector("span");
            if (initialLabel) {
              updateLogos(initialLabel.textContent.trim());
            }
          }

          // Add event listeners to update logos on change
          const radios = option.querySelectorAll("input[type='radio']");
          radios.forEach((radio) => {
            radio.addEventListener("change", () => {
              const selectedLabel = radio.nextElementSibling.querySelector("span");
              if (selectedLabel) {
                updateLogos(selectedLabel.textContent.trim());
              }
            });
          });
        }

        if (isNixodineOption) {
          // Ensure Nixodine logo is activated
          const activateNixodineLogo = () => {
            resetLogos();
            logos.nix?.classList.add("active-logo");
          };

          activateNixodineLogo();

          // Add event listeners for Nixodine options
          const radios = option.querySelectorAll("input[type='radio']");
          radios.forEach((radio) => {
            radio.addEventListener("change", activateNixodineLogo);
          });
        }
      });
    } else {
      console.log("No valid variant picker found");
    }
  };

  // Listener for variant:change event
  document.addEventListener("variant:change", () => {
    const selectedLabels = getSelectedLabels();
    selectedLabels.forEach((label) => {
      if (label.includes("mg")) {
        updateLogos(label);
      }
    });
  });

  // Initialize the variant picker
  initializeVariantPicker();
});